// import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import conf from "../config";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import Cookies from "js-cookie";
import utf8 from "utf8";
import config from "../config";
import { getCached, setCached, invalidateCache } from "./cacheStore";

class WASLCompanyStore {
  WASLCompanyArray = [];
  WASLCompanyStatus = [];
  inquiryStatus = [];
  waslactivity = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      WASLCompanyArray: observable,

      inquiryStatus: observable,
      total: observable,
      loading: observable,
      loadData: action,
      getCompanyInfo: action,
      getWASLCompanyStatus: action,
      deleteRecord: action,
      getwaslactivity: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ searchField, offset, limit, UcompanyId }) {
  

    var postData = {
      searchField: searchField,
      UcompanyId: UcompanyId,
      offset: offset,
      limit: limit,
    };

    const cacheKey = `waslcompanyList:${offset}:${limit}:${searchField}:${UcompanyId}`;
    const cached = getCached(cacheKey);

    if (cached) {
      this.WASLCompanyArray = cached.WASLCompanyArray;
      this.total = cached.total;
      return;
    }
      this.loading = true;


    var base64Input = await base64_encode(JSON.stringify(postData));
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .post(config.NodeUrl + "/company/waslcompanylist", postData);
    }
    else {

      var response = await postApi
        .getClient()
        .post("index.php?c=wasl&a=companyList", "postData=" + base64Input);
    }

    
    
    const WASLCompanyArray = response?.data?.data?.company;
    const total     = parseInt(response?.data?.data?.TotalCount);

    setCached(cacheKey, { WASLCompanyArray, total });

      this.WASLCompanyArray = WASLCompanyArray;
      this.total     = total;
      this.loading   = false;
  }

  async registerCompany(data) {
    var postData = data;
    const base64Input = await base64_encode(JSON.stringify(postData));
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .post(config.NodeUrl + "/company/waslcompanyregister", postData);
    }
    else {
      var response = await postApi
        .getClient()
        .post("index.php?c=wasl&a=registerCompany", "postData=" + base64Input);
    }

     invalidateCache('waslcompanyList');

    return response;
  }

  async getCompanyInfo(companyId) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .post(config.NodeUrl + "/company/waslcompanyInfo", postData);
    }
    else {
      var response = await postApi
        .getClient()
        .post("index.php?c=wasl&a=getCompanyInfo", "postData=" + base64Input);
    }

    return response.data.data;
  }

  // async exportExcel(getData) {
  //   if(config.pythonReport==1){
  //       var response = await postApi
  //     .getClient()
  //     .post("http://127.0.0.1:3059/company/waslcompanyexcel", getData);
  //   }else{
  //   window.location.href =
  //     conf.baseURL +
  //     "index.php?c=wasl&a=exportwaslcompanyexcel&cid=" +
  //     getData.cid +
  //     "&UcompanyId=" +
  //     getData.UcompanyId +
  //     "&colList=" +
  //     getData.colList +
  //     "&searchField=" +
  //     getData.searchField;
  //   }
  //   // window.location.href = conf.baseURL + "index.php?c=company&a=exportCompanyExcel&dType=" +getData.dType+ '&isadmin='+getData.isadmin+ '&cid='+getData.cid+ '&cType='+getData.cType +'&cName='+getData.cName + '&email='+getData.email+ '&colList='+getData.colList

  // }

  async exportExcel(getData) {
    if (config.pythonReport == 1) {
      try {
        const response = await postApi
          .getClient()
          .post(config.NodeUrl + "/company/waslcompanyexcel", getData, {
            responseType: 'blob'  // ← ADD THIS!
          });

        // Create download link
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'wasl_company_report.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Export failed:', error);
      }
    } else {
      window.location.href =
        conf.baseURL +
        "index.php?c=wasl&a=exportwaslcompanyexcel&cid=" +
        getData.cid +
        "&UcompanyId=" +
        getData.UcompanyId +
        "&colList=" +
        getData.colList +
        "&searchField=" +
        getData.searchField;
    }
  }


  async deleteRecord({ Id, companyId, waslkey, userId }) {
    var postData = {
      waslId: Id,
      companyId: companyId,
      waslKey: waslkey,
      userId: userId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .post(config.NodeUrl + "/company/waslcompanydelete", postData);

    }
    else {

      var response = await postApi
        .getClient()
        .post("index.php?c=wasl&a=deleteCompany", "postData=" + base64Input);
    }
     invalidateCache('waslcompanyList');
    return response;
  }

  async getWASLCompanyStatus(record) {
    var postData = { Id: record.Id, waslKey: record.waslKey };

    const base64Input = await base64_encode(JSON.stringify(postData));
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .post(config.NodeUrl + "/company/waslcompanystatus", postData);

      if (response?.data?.data) {
        this.inquiryStatus = response?.data?.data;
      }
      if (!response?.data?.data) {
        this.WASLCompanyStatus = response?.data?.message;
      }
    }
    else {
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=wasl&a=getwaslcompanystatus",
          "postData=" + base64Input
        );
      if (response?.data?.data) {
        this.inquiryStatus = JSON.parse(response?.data?.data);
        // console.log("DDDDDDDDDDDD",this.inquiryStatus);
      } else {
        this.WASLCompanyStatus = response?.data?.errors[0][0];
      }
    }
    return response?.data?.data;
  }

  async getwaslactivity() {
    var postData = {
      roleId2: Number(JSON.parse(base64_decode(Cookies.get("data"))).roleId2),
      userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
      status: 1

    }
    console.log(postData, 'postddddddata')
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/vehicle/getwaslactivity", {
        postData
      });
    this.waslactivity = response?.data.data
    console.log(response?.data.data);
    return response?.data;
  }


}

export default WASLCompanyStore;
